import messages from '../../../../locale/messages';

const validate = values => {
    const errors = {};

    if (!values.infoTitle1) {
        errors.infoTitle1 = messages.required;
    } else if (values.infoTitle1.trim() == "") {
        errors.infoTitle1 = messages.required;
    }

    if (!values.infoTitle2) {
        errors.infoTitle2 = messages.required;
    } else if (values.infoTitle2.trim() == "") {
        errors.infoTitle2 = messages.required;
    }

    if (!values.infoTitle3) {
        errors.infoTitle3 = messages.required;
    } else if (values.infoTitle3.trim() == "") {
        errors.infoTitle3 = messages.required;
    }


    if (!values.infoContent1) {
        errors.infoContent1 = messages.required;
    } else if (values.infoContent1.trim() == "") {
        errors.infoContent1 = messages.required;
    }

    if (!values.infoContent2) {
        errors.infoContent2 = messages.required;
    } else if (values.infoContent2.trim() == "") {
        errors.infoContent2 = messages.required;
    }

    if (!values.infoContent3) {
        errors.infoContent3 = messages.required;
    } else if (values.infoContent3.trim() == "") {
        errors.infoContent3 = messages.required;
    }

    return errors;
};

export default validate;